import api from "utils/api";

//스케쥴관리 > 개설된 강습 정보
export const getAttendanceScheduleList = async () => {
    try {
        const res = await api.get(`/buccl_lessons/api/v2/attendances/`);
        return res.data;
    } catch (error) {
        return [];
    }
};

export const getAttendanceScheduleDetail = async (id, type) => {
    try {
        const queryParams = type === "practice" ? `?type=${type}` : "";
        const res = await api.get(
            `/buccl_lessons/api/v2/attendances/${id}/${queryParams}`
        );
        return res.data;
    } catch (error) {}
};

// 강습 수정

// export const editClassSchedule = async (id, params) => {
//     try {
//         const res = await api.put(
//             `/buccl_lessons/api/v1/instructor-schedules/${id}/`,
//             params
//         );
//         return res.data;
//     } catch (error) {}
// };

export const editClassSchedule = async (id, params) => {
    try {
        const res = await api.patch(
            `/buccl_lessons/api/v1/instructor-schedules/${id}/`,
            params
        );
        return res;
    } catch (error) {
        return error.response;
    }
};

export const editPracticeSchedule = async (id, data) => {
    try {
        const response = await api.patch(`/buccl_lessons/api/v1/practice-schedules/${id}/`, data);
        return response;
    } catch (error) {
        return error.response;
    }
};
